import { createSlice } from '@reduxjs/toolkit';
import { fetchUserList } from './thunk';

export type user = {
    createdAt: string;
    userId: any;
    _id: string
    userType: string,
    name: string,
    mobileNumber: string,
    state: string,
    city: string,
    area: any,
    experience?: string,
    certificates?: string,
    awards?: string,
    isApproved?:boolean
    isVerified?:boolean,
}

export type userFilterType = {
    userType: string;
    state: string;
    city: string;
    area: string;
    search: string;
    sortBy: string | null;
    sortOrder: "asc" | "desc" | null;
    totalCount: number;
    page: number;
    limit: number;
};

interface CommonState {
    usersList: user[];
    filterData: userFilterType;
    loading: {
        usersList: boolean;
    };
}

const initialState: CommonState = {
    loading: {
        usersList: false,
    },
    filterData: {
        userType: "",
        state: "",
        city: "",
        area: "",
        search: "",
        sortBy: "",
        sortOrder: null,
        totalCount: 0,
        page: 1,
        limit: 10,
    },
    usersList: [],
};

const userSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        setUserList(state, action) {
            state.usersList = action.payload
        },
        setFiletrData(state, action) {
            state.filterData = action.payload
        },
        setClearFilters(state) {
            state.filterData = initialState.filterData
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserList.pending, (state) => {
                state.loading.usersList = true;
                state.usersList = []
            })
            .addCase(fetchUserList.fulfilled, (state, action) => {                        
                state.loading.usersList = false;
                state.usersList = action.payload.data as any;
                state.filterData = {
                  ...state.filterData,
                  ...action.payload.filterData,
                };
              })
            .addCase(fetchUserList.rejected, (state, action) => {
                state.loading.usersList = false;
                state.usersList = []
            });
    },
});

export const { setUserList, setFiletrData, setClearFilters } = userSlice.actions;

export default userSlice.reducer;
